/**
 *
 * DebugGraph
 *
 */

import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import cytoscape from 'cytoscape';

export class DebugGraph extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      graph: '[ { "edges": { "1": [ { "up": null, "down": 3 } ], "2": [ { "up": null, "down": 3 } ]} }, {"left": "first name", "edges": { "1": [ { "up": 3, "down": null } ]}}, {"left": "last name", "edges": { "2" : [ { "up": 3, "down": null } ]}}, {"left": "has_name", "op": "eq", "right": "yes", "edges": { "1": [ { "up": 0, "down": 1 } ], "2": [ { "up": 0, "down": 2 } ]}} ]',
      fieldKeys: '{}',
    };
  }

  componentDidMount() {
    this.renderGraph();
  }

  arange(min, max, bins, base = 10, pad = false) {
    const limit = (max - min) + 1;
    const step = Math.floor(limit / bins);
    const range = [...new Array(bins)].map((_, index) => ((index * step) + min)).map((v) => v.toString(base));
    range[0] = min.toString(base);
    range[range.length - 1] = max.toString(base);
    if (pad) {
      const maxLen = range[range.length - 1].length;
      return range.map((e) => e.length < maxLen ? `${[...new Array(maxLen - e.length)].map(() => '0').join('')}${e}` : e);
    }
    return range;
  }

  updateGraph() {
    let fields = {};
    let graph = [];
    try {
      fields = JSON.parse(this.state.fieldKeys) || {};
      graph = JSON.parse(this.state.graph);
    } catch (e) {
      return null;
    }
    const paths = Object.keys(graph[0].edges);
    const colors = (paths.length ? this.arange(15, 3840, paths.length, 16, true) : []).reduce((memo, color, index) => ({ ...memo, [paths[index]]: color }), {});
    const style = [
      {
        selector: 'node',
        style: {
          'background-color': '#66F',
          label: 'data(label)',
        },
      },
    ];

    const templateStyle = {
      width: 3,
      'target-arrow-shape': 'circle',
      'curve-style': 'bezier',
    };

    const elements = graph.map((vertex, index) => {
      const group = [{
        data: {
          id: `${index}`,
          label: `${vertex.left ? (fields[vertex.left] ? fields[vertex.left].name : vertex.left) : 'Root'} ${vertex.op ? vertex.op : ''} ${vertex.right ? vertex.right : ''}`, // eslint-disable-line
        },
      }];
      Object.keys(vertex.edges).forEach((key) => {
        vertex.edges[key].forEach((edge, edgeIndex) => {
          if (edge.up !== null) {
            const dataKey = `${key}-${index}-${edgeIndex}`;
            group.push({
              data: {
                id: dataKey,
                source: `${edge.up}`,
                target: `${index}`,
              },
            });
            style.push({
              selector: `#${dataKey}`,
              style: {
                ...templateStyle,
                'line-color': `#${colors[key]}`,
                'target-arrow-color': `#${colors[key]}`,
              },
            });
          }
        });
      });
      return group;
    }).flat();
    return {
      elements,
      style,
    };
  }

  renderGraph() {
    const cyGraph = this.updateGraph();
    if (cyGraph) {
      this.cy = cytoscape({
        container: document.getElementById('cy'),
        layout: { name: 'breadthfirst', circle: true, maximal: true },
        ...cyGraph,
      });
    }
  }

  render() {
    return (
      <div>
        <div className="row">
          <div className="col-md-12">
            <h4>How to use</h4>
            <p>
              Copy the graph object (just the array) from Redux, convert it to a JSON object and paste it in the Graph Array field.  Optionally you can also
              copy one or more field objects from Redux, convert them to JSON and paste them in the Field Name Replacements field below.
            </p>
          </div>
        </div>
        <div style={{ width: '100%', marginTop: '10px', marginBottom: '10px' }}>
          <div
            id="cy"
            style={{ width: '95%', height: '800px', border: 'solid 2px gray', margin: 'auto' }}
          />
        </div>
        <div className="container-fluid" style={{ borderTop: 'solid 3px black' }}>
          <div className="row">
            <div className="col-md-8">
              <h4>Graph Array</h4>
              <textarea
                style={{ width: '100%', height: '100%', border: '1px solid lightgray' }}
                value={this.state.graph}
                onChange={(e) => { this.setState({ graph: e.target.value }); }}
                onBlur={() => { this.renderGraph(); }}
              />
            </div>
            <div className="col-md-4">
              <h4>Field Name Replacements</h4>
              <textarea
                style={{ width: '100%', height: '100%', border: '1px solid lightgray' }}
                value={this.state.fieldKeys}
                onChange={(e) => { this.setState({ fieldKeys: e.target.value }); }}
                onBlur={() => { this.renderGraph(); }}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function mapDispatchToProps() {
  return {};
}

const withConnect = connect(null, mapDispatchToProps);

export default compose(
  withConnect,
)(DebugGraph);
